import { Dispatch } from '@reduxjs/toolkit';
import qs from 'qs';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Invoice } from 'dashboard/models/invoice';
import { setStripeInvoicePdfUrl } from 'dashboard/redux/actions/invoice';
import { ApiEndpoint } from 'lib/interfaces/api';

export function loadStripeInvoicePdfUrl(invoice: Invoice) {
  return async (dispatch: Dispatch) => {
    const params = {
      invoice_id: invoice.id,
      stripe_invoice_id: invoice.attributes['stripe-invoice-id'],
    };
    const stripeInvoicePdfUrlResponse = (await SessionClientDashboard.getResourceMeta<string>(
      ApiEndpoint.Invoice,
      `stripe-invoice-pdf-url?${qs.stringify(params)}`,
    )) as unknown as string;
    dispatch(setStripeInvoicePdfUrl(stripeInvoicePdfUrlResponse));
    return stripeInvoicePdfUrlResponse;
  };
}
